import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import WeKitLogo from "@/components/WeKitLogo";
import FaqSection from "@/components/FaqSection";
import SharedFooter from "@/components/SharedFooter";
import PageHead from "@/components/PageHead";

export default function Faqs() {
  return (
    <div className="theme-reading min-h-screen bg-background text-foreground flex flex-col">
      <PageHead
        title="Frequently Asked Questions | WeKIT™ Career Clarity 360"
        description="Answers about the WeKIT™ Career Clarity 360 journey — how the assessment works, what your report includes, pricing, privacy and support."
        path="/faqs"
      />
      <header className="sticky top-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-xl">
        <div className="container mx-auto flex h-16 items-center justify-between px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2">
            <WeKitLogo size="sm" />
            <span className="font-display text-lg font-bold text-foreground">WeKIT™</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="container mx-auto px-4 pt-10 sm:px-6">
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-foreground">
            Frequently Asked Questions
          </h1>
          <p className="mt-2 max-w-2xl text-muted-foreground">
            Everything you might want to know before you start your Career Clarity 360™ journey.
          </p>
        </div>
        <FaqSection />
      </main>

      <SharedFooter />
    </div>
  );
}

